export default __webpack_public_path__ + "static/media/menu.b3ebf8f3.svg";